import React from "react";
import ClientSignupStyles from "../../Styles/SignUp/ClientSignup.module.css";
import Login from "../../Component/Login/Login";

const ClientSignIn = () => {
  const { main } = ClientSignupStyles;
  return (
    <main className={main}>
      <Login />
    </main>
  );
};

export default ClientSignIn;
